import React from 'react'
import { Link } from 'react-router-dom'
import rawResources from '../../../database/resources.json'
import { normalizer } from '../../../utils'
const normalizedResources = normalizer(rawResources)

const resourceCategory = {
  kebijakan: 2,
  hasilPenelitian: 3,
  kasus: 7,
}

const SummaryItem = ({data}) => {
  return (
    <div className="bg-white py-5 lg:py-10" style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}>
      <h3 className="text-lg lg:text-5xl font-bold font-accent lg:mb-2">{data.value}</h3>
      <div className="font-bold">{data.name}</div>
    </div>
  )
}

const Summaries = ({data}) => {
  const [summaryData, setSummaryData] = React.useState([])

  React.useEffect(() => {
    if(data){
      if(data.resources && data.resources.length > 0){
        const regionResources = data.resources.map(d => normalizedResources[d])

        let temp = {
          kebijakan: 0,
          hasilPenelitian: 0,
          kasus: 0,
        }

        for (let index = 0; index < regionResources.length; index++) {
          const resource = regionResources[index];
          if(resource.categories.includes(resourceCategory.kebijakan)){
            temp.kebijakan++
          }
          if(resource.categories.includes(resourceCategory.hasilPenelitian)){
            temp.hasilPenelitian++
          }
          if(resource.categories.includes(resourceCategory.kasus)){
            temp.kasus++
          }
        }

        const result = [
          {
            name: 'Kebijakan',
            value: temp.kebijakan,
            route: 'kebijakan-kota-daerah'
          },
          {
            name: 'Hasil Penelitian',
            value: temp.hasilPenelitian,
            route: 'hasil penelitian'
          },
          {
            name: 'Inisiatif',
            value: data.initiatives ? data.initiatives.length : 0,
            route: 'inisiatif'
          },
          {
            name: 'Organisasi',
            value: data.organizations ? data.organizations.length : 0,
            route: 'organisasi'
          },
          {
            name: 'Kasus',
            value: temp.kasus,
            route: 'kasus'
          },
        ]

        setSummaryData(result)
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <div className="flex flex-wrap -mx-4 py-12 lg:py-24">
      {
        summaryData &&
        summaryData.map((d, i) => (
          <div className={`w-1/2 sm:w-4/12 ${i < 2 ? 'md:w-1/2' : 'md:w-4/12'} px-4 mb-4 lg:mb-8 text-center`} key={i}>
            <Link to={`/region/detail/${data.id}/${d.route}`}>
              <SummaryItem data={d}/>
            </Link>
          </div>
        ))
      }
    </div>
  )
}

export { Summaries }